import { DEFAULT_WIDGET_SPACING } from '../../spacing';
import type { FrontendWidget } from '../../types';
import { TwoColumnLayoutComponent } from './TwoColumnLayoutComponent';
import type { TwoColumnLayoutConfig, TwoColumnLayoutResolved } from './types';

export const twoColumnLayoutWidget: FrontendWidget<
  TwoColumnLayoutConfig,
  TwoColumnLayoutResolved
> = {
  componentType: 'layouts.two-column-layout',
  // 70.14: SlotRenderer adds no container — arranges other widgets: the columns are the container its children sit in.
  layout: 'self',
  displayName: 'Two Column Layout',
  defaultValues: { ratio: '1-1', leftColumn: [], rightColumn: [] },
  ComponentA: TwoColumnLayoutComponent,
  resolveSync: (config) => ({
    ...config,
    // Mirrors the Strapi default, for entries written before the field existed.
    spacing: config.spacing ?? DEFAULT_WIDGET_SPACING,
  }),
};
